import { create } from "zustand";

export interface Toast {
  id: string;
  level: "info" | "ok" | "warn" | "critical";
  title: string;
  detail?: string;
  /** ms — Infinity for sticky. Default 5000. */
  duration?: number;
  /** Optional action shown as a button. */
  action?: { label: string; onAction: () => void };
}

interface ToastState {
  toasts: Toast[];
  push(t: Omit<Toast, "id">): string;
  dismiss(id: string): void;
}

export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push: (t) => {
    const id = `t-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    const toast: Toast = { id, ...t };
    set((s) => ({ toasts: [...s.toasts, toast] }));
    const dur = t.duration ?? 5000;
    if (dur !== Infinity) {
      window.setTimeout(() => {
        set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) }));
      }, dur);
    }
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}));

export function pushToast(t: Omit<Toast, "id">) {
  return useToasts.getState().push(t);
}
